var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('title-component',{attrs:{"slot":"title","type":"h2","title":_vm.$t('programs.create.title')},slot:"title"}),_c('program-template')],1)}
var staticRenderFns = []

export { render, staticRenderFns }